import { useEffect, useState } from "react";

const sm = 640 as const;
const md = 768 as const;
const lg = 1024 as const;

const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState({ width: window.innerWidth, height: window.innerHeight });

  const handleSize = () => {
    setWindowSize({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  };

  useEffect(() => {
    handleSize();

    window.addEventListener("resize", handleSize);

    return () => window.removeEventListener("resize", handleSize);
  }, []);

  return { width: windowSize.width, height: windowSize.height, sm, md, lg };
};

export default useWindowSize;
